export const award = (e) => {
    return {
        as: `/a/${e.slug}.${e.id}`,
        href: `/a/[award]`,
    };
}

export const organisation = (e) => {
    return {
        as: `/o/${e.slug}.${e.id}`,
        href: `/o/[organisation]`,
    };
}

export const category = (e) => {
    return {
        as: `/c/${e.slug}.${e.id}`,
        href: `/c/[category]`,
    };
}

export const nominate = (e) => {
    return {
        as: `/nominate/${e.slug}.${e.id}`,
        href: `/nominate/[nominate]`,
    };
}

export const nominee = (e, a) => {
    return {
        as: `/n/${a.slug}.${a.id}/${e.slug}.${e.id}`,
        href: `/n/[category]/[nominee]`,
    };
}

export const result = (e, award = false) => {
    return {
        as: `/${award ? 'ra' : 'r'}/${e.slug}.${e.id}`,
        href: `/${award ? 'ra' : 'r'}/[result]`,
    };
}

export const ticket = (e) => {
    return {
        as: `/t/${e.slug}.${e.id}`,
        href: `/t/[ticket]`,
    };
}